module.exports = __webpack_public_path__ + "static/section5-25955ceadd4ff93ee3dfa13605ff62a8.png";